<template>
    <v-container grid-list-xs>
        <v-dialog v-model="dialog" width="500">

            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    Причины
                </v-card-title>

                <v-card-text>
                    <v-form ref="form" lazy-validation>
                        <v-text-field v-model="dt.name" label="название" required></v-text-field>
                        <v-text-field v-model="dt.info" label="название" required></v-text-field>
                    
                    </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn color="success" class="mr-4" @click="SaveUser">
                        Сохранить
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="error" class="mr-4" @click="dialog = false">
                        Отменить
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-row>
            <v-col cols="12" md="6">
                <h1>Причины доставки</h1>
            </v-col>
            <v-col cols="12" md="6">
                <v-btn class="btn" @click="newData">Добавить</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                        Список
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Поиск" single-line
                            hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="desserts" :search="search" @click:row="openData"></v-data-table>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>
  
<script>
// @ is an alias to /src


export default {
    name: 'Home',
    data: () => ({
        dt: {
            id: 0,
            name: '',
            info: '',
        },
        dialog: false,
        search: '',
        headers: [
          {
            text: 'id',
            align: 'start',
            value: 'id',
          },
          { text: 'название', value: 'nameCause' },
          { text: 'описание', value: 'info' },
        ],
        
    }),

    components: {

    },
    computed: {
        desserts() {
          return this.$store.getters.listCause;
        },
    },
    methods: {
        newData(){
            this.dt.id = 0;
            this.dt.name = '';
            this.dt.info = '';
            this.dialog = true;
        },
        SaveUser() {
            this.$store.dispatch("newlistCause", this.dt);
            this.dialog = false;
        },
        openData(e){
            this.dt.id = e.id;
            this.dt.name = e.nameCause;
            this.dt.info = e.info;
            this.dialog = true;
        }
    },
    mounted() {
        this.$store.dispatch("getlistCause");
    }
}
</script>
  